import React from "react";
import { Routes, Route } from "react-router-dom";
import FaqDetail from "./faq-detail";

//
const Faq = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route path="" element={<FaqDetail />} />
         <Route path="/" element={<FaqDetail />} />
      </Routes>
    </React.Fragment>
  );
};

export default Faq;
